import styled from 'styled-components'
import { Field } from 'formik'

export const RangeInputField = styled(Field)`
  border: none;
  border-radius: 0;
  outline: none;
  color: ${({ theme }) => theme.text1};
  width: 100%;
  height: 25px;
  -webkit-appearance: none;
  background: ${({ theme }) => theme.bg6};
  opacity: 1;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    background: ${({ theme }) => theme.bg7};
    cursor: pointer;
    z-index: 10;
  }
`

export const RangeInputWrapper = styled.div`
  position: relative;
  margin-left: -3px;
  .range-color {
    margin-left: 2px;
    position: absolute;
    height: 25px;
    background: ${({ theme }) => theme.bg7};
    top: 2px;
    opacity: 0.7;
    z-index: 9;
  }
`
